module.exports = __webpack_public_path__ + "static/img/index_img_3.cfb2486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_img_3.jpg
// module id = mY8d
// module chunks = 0